"use strict";
var $ = require("../internals/export");
var call = require("../internals/function-call");
var aCallable = require("../internals/a-callable");
var anObject = require("../internals/an-object");
var getIteratorDirect = require("../internals/get-iterator-direct");
var createIteratorProxy = require("../internals/iterator-create-proxy");
var callWithSafeIterationClosing = require("../internals/call-with-safe-iteration-closing");
var IS_PURE = require("../internals/is-pure");
var iteratorClose = require("../internals/iterator-close");
var iteratorHelperThrowsOnInvalidIterator = require("../internals/iterator-helper-throws-on-invalid-iterator");
var iteratorHelperWithoutClosingOnEarlyError = require("../internals/iterator-helper-without-closing-on-early-error");
var FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR = !IS_PURE && !iteratorHelperThrowsOnInvalidIterator("filter", function() {
});
var filterWithoutClosingOnEarlyError = !IS_PURE && !FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR && iteratorHelperWithoutClosingOnEarlyError("filter", TypeError);
var FORCED = IS_PURE || FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR || filterWithoutClosingOnEarlyError;
var IteratorProxy = createIteratorProxy(function() {
  var iterator = this.iterator;
  var predicate = this.predicate;
  var next = this.next;
  var result, done, value;
  while (true) {
    result = anObject(call(next, iterator));
    done = this.done = !!result.done;
    if (done) return;
    value = result.value;
    if (callWithSafeIterationClosing(iterator, predicate, [value, this.counter++], true)) return value;
  }
});
$({ target: "Iterator", proto: true, real: true, forced: FORCED }, {
  filter: function filter(predicate) {
    anObject(this);
    try {
      aCallable(predicate);
    } catch (error) {
      iteratorClose(this, "throw", error);
    }
    if (filterWithoutClosingOnEarlyError) return call(filterWithoutClosingOnEarlyError, this, predicate);
    return new IteratorProxy(getIteratorDirect(this), {
      predicate
    });
  }
});
